"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var XSDDate_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.XSDDate = void 0;
const RdfsLiteral_1 = require("lincd-rdfs/lib/shapes/RdfsLiteral");
const models_1 = require("lincd/lib/models");
const xsd_1 = require("../ontologies/xsd");
const package_1 = require("../package");
let XSDDate = XSDDate_1 = class XSDDate extends RdfsLiteral_1.RdfsLiteral {
    get year() {
        return new Date(this.toDateTime()).getFullYear();
    }
    get month() {
        return new Date(this.toDateTime()).getMonth();
    }
    get literalMonth() {
        var m = this.month;
        return XSDDate_1.literalMonths[m];
    }
    get day() {
        return new Date(this.toDateTime()).getDate();
    }
    get hours() {
        return new Date(this.toDateTime()).getHours();
    }
    get minutes() {
        return new Date(this.toDateTime()).getMinutes();
    }
    get seconds() {
        return new Date(this.toDateTime()).getSeconds();
    }
    static now() {
        var current = new Date();
        var value = current.toISOString();
        return new models_1.Literal(value, this.targetClass);
    }
    static fromTimestamp(timestamp) {
        let native = new Date(typeof timestamp === 'string' ? parseInt(timestamp) : timestamp);
        return this.fromNativeDate(native);
    }
    static fromNativeDate(nativeDate) {
        if (!nativeDate)
            return null;
        var value = nativeDate.toISOString();
        let literal = new models_1.Literal(value, XSDDate_1.targetClass);
        return new XSDDate_1(literal);
    }
    static toNativeDate(literal) {
        return literal ? new Date(literal.value) : null;
    }
    toDateTime() {
        // return this.value.indexOf("T") !== -1 ? this.value : this.value+"T00:00:00";
        return this.value.indexOf('T') !== -1
            ? this.value.replace(/-/g, '/').replace(/T.+/, '')
            : this.value.replace(/-/g, '/');
    }
};
exports.XSDDate = XSDDate;
XSDDate.targetClass = xsd_1.xsd.date;
XSDDate.literalMonths = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
exports.XSDDate = XSDDate = XSDDate_1 = __decorate([
    package_1.linkedShape
], XSDDate);
//# sourceMappingURL=XSDDate.js.map